<template>
  <!-- wyświetlanie prowizji -->
  <div v-if="PaymentFee.isPaymentFeeActive() && !dccDetails">
    <p class="customer-fee" v-if="PaymentFee.isConfirmationView()">
      <span>{{ $t('orderDetails.customerFeePaymentText', {fee: `${PaymentFee.getPaymentFeeAsSingleValue()} ${getTransactionPayCurrency()}`}) }}</span>
    </p>
    <p class="customer-fee" v-else>
      <span v-if="PaymentFee.isPaymentFeeLegacyMode()">
        {{ $t('orderDetails.customerFeePaymentText', {fee: `${PaymentFee.getPaymentFeeAsSingleValue()} ${getTransactionPayCurrency()}`}) }}
      </span>
      <span v-else>
        <span v-if="!PaymentFee.isPaymentFeeDifferent()">
          {{ $t('orderDetails.feeLabel') }}: {{ PaymentFee.getPaymentFeeAsSingleValue() | amount }} {{ getTransactionPayCurrency() }}
        </span>
        <span v-if="PaymentFee.isPaymentFeeDifferent() && selectedPaywayGroupType">
          <span v-if="!paywayID">{{ $t('orderDetails.customerFeeGroupText') }}: {{ PaymentFee.getPaymentFeeForGroup(selectedGroup) }}</span>
          <span v-if="paywayID">{{ $t('orderDetails.customerFeePaymentText', {fee: PaymentFee.getPaymentFeeForPayway(selectedPayway)}) }}</span>
        </span>
      </span>
    </p>

  </div>
</template>

<script>
import orderDetailsMixin from '@/base/mixins/orderDetails.mixin'
import { PaymentFee } from '../../class/paymentFee.class'
export default {
  name: 'OrderDetailsFee',
  mixins: [orderDetailsMixin],
  computed: {
    PaymentFee () {
      return PaymentFee
    }
  }
}
</script>
